import classNames from 'classnames';
import React from 'react';
import {useShallow} from 'zustand/react/shallow';

import {Button, IconButton, Text} from '@albert-io/atomic';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function StudentHomepageHeader({className}: PropsWithClassNameOptional) {
  const {isSidebarExpanded, setIsSidebarExpanded, setShowJoinClassModal} = useStudentDashboard(
    useShallow((state) => ({
      isSidebarExpanded: state.isSidebarExpanded,
      setIsSidebarExpanded: state.setIsSidebarExpanded,
      setShowJoinClassModal: state.setShowJoinClassModal
    }))
  );

  return (
    <div className={classNames('flex items-center px-x3 pt-x3', className)}>
      <IconButton
        className='mr-x1'
        icon='bars'
        label='Toggle sidebar button'
        onClick={() => {
          setIsSidebarExpanded(!isSidebarExpanded);
        }}
      />
      <Text className='mr-x2 flex-1 font-black' size='xl'>
        Home
      </Text>
      <Button onClick={() => setShowJoinClassModal(true)} roundness='pill'>
        Join Class
      </Button>
    </div>
  );
}
